module.exports = __webpack_public_path__ + "img/productivity-urls.c18752e0.webp";